import { request } from 'src/utils/utils';
import { stringify } from 'qs';

const urls = {
  messageList: '/neoericBacklog/message/queryPage', // 获取消息列表
  markRead: '/neoericBacklog/message/markReadMessages', // 标记已读
  getmessageDetail: '/neoericBacklog/message/queryMessageDetail', // 查看详情
};

export async function getMessageList(params) {
  return request(`${urls.messageList}?${stringify(params)}`);
}

export async function markMessageRead(data) {
  return request(urls.markRead, { method: 'POST', data });
}

export async function getmessageDetail(params) {
  return request(`${urls.getmessageDetail}?${stringify(params)}`);
}
